<template>
  <svg
    :width="dimensions.width"
    :height="dimensions.height"
    :viewBox="`0 0 ${dimensions.width} ${dimensions.height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1" clip-path="url(#clip0_605_3961)">
      <g id="Group">
        <g id="Group_2">
          <path id="Vector" d="M4.125 28.9727C4.125 36.3627 10.102 42.3397 17.4921 42.3397L15.487 38.998" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
          <path id="Vector_2" d="M42.3163 17.5155C42.3163 10.1254 36.3393 4.14844 28.9492 4.14844L30.9543 7.49021" stroke="#435363" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"
          />
        </g>
        <path id="Vector_3" d="M38.5728 34.9121V38.5785C38.5728 41.672 35.6894 44.1927 32.1185 44.1927C28.5475 44.1927 25.6641 41.6911 25.6641 38.5785V34.9121C25.6641 38.0056 28.5475 40.2207 32.1185 40.2207C35.6894 40.2207 38.5728 38.0056 38.5728 34.9121Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
        <path id="Vector_4" d="M38.5728 29.9662C38.5728 30.8637 38.3246 31.7039 37.8854 32.4104C36.816 34.1482 34.6391 35.2748 32.1185 35.2748C29.5978 35.2748 27.4209 34.1673 26.3515 32.4104C25.9123 31.7039 25.6641 30.8637 25.6641 29.9662C25.6641 28.4194 26.3897 27.0254 27.5546 26.0133C28.7194 24.9822 30.3234 24.3711 32.1185 24.3711C33.9135 24.3711 35.5175 25.0013 36.6824 26.0133C37.8472 27.0445 38.5728 28.4385 38.5728 29.9853V29.9662Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
        <path id="Vector_5" d="M38.5728 29.7381V34.5121C38.5728 37.491 35.6894 39.6107 32.1185 39.6107C28.5475 39.6107 25.6641 37.491 25.6641 34.5121V29.7381C25.6641 26.7592 28.5475 24.334 32.1185 24.334C33.9135 24.334 35.5175 24.9451 36.6824 25.9189C37.8472 26.8928 38.5728 28.2486 38.5728 29.7381Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
      </g>
      <path id="Vector_6" d="M13.6534 14.8047C15.2384 14.8047 16.5178 16.0841 16.5178 17.6691V22.443H10.7891V17.6691C10.7891 16.0841 12.0685 14.8047 13.6534 14.8047Z" stroke="#435363" stroke-width="2" stroke-linejoin="round"/>
      <path id="Vector_7" d="M11.7031 3.9967L4.69491 9.61087C3.91198 10.241 3.39639 11.5586 3.56825 12.5516L4.92406 20.6101C5.1723 22.0423 6.5472 23.2071 7.99849 23.2071H19.3414C20.7927 23.2071 22.1676 22.0232 22.4158 20.6101L23.7716 12.5516C23.9244 11.5586 23.4279 10.241 22.645 9.61087L15.6368 3.9967C14.5484 3.11829 12.8106 3.11829 11.7222 3.9967H11.7031Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_605_3961">
        <rect width="45.83" height="45.83" fill="white" transform="translate(0.304688 0.330078)"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    height: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    useCustomDimensions: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultWidth: 47,
      defaultHeight: 47,
    };
  },
  computed: {
    dimensions() {
      return {
        width: this.useCustomDimensions ? this.width : this.defaultWidth,
        height: this.useCustomDimensions ? this.height : this.defaultHeight,
      };
    },
  },
};
</script>
